
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class GraderCountBadge extends Vue {
  @Prop() queueLength!: number;
  @Prop() error!: boolean;

  get graderCounter(): string {
    if (this.error === true) {
      return '?';
    } else if (this.queueLength === -1) {
      return '…';
    }
    return `${this.queueLength}`;
  }

  get graderBadgeClass(): string {
    if (this.queueLength === -1 && this.error === false) {
      return '';
    } else if (this.error === true) {
      return 'grader-error';
    } else if (this.queueLength < 5) {
      return 'grader-ok';
    }
    return 'grader-warning';
  }
}
